import { render, staticRenderFns } from "./ComplieAddModelAssociation.vue?vue&type=template&id=a16ad852&scoped=true"
import script from "./ComplieAddModelAssociation.vue?vue&type=script&lang=js"
export * from "./ComplieAddModelAssociation.vue?vue&type=script&lang=js"
import style0 from "./ComplieAddModelAssociation.vue?vue&type=style&index=0&id=a16ad852&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16ad852",
  null
  
)

export default component.exports